import { Controller } from "@hotwired/stimulus"

// Drives the Stripe Payment Element on the guardian checkout page: fetches a
// PaymentIntent client secret from the server, mounts the element, and
// confirms the payment. The order's paid state is settled by the Stripe
// webhook, not by this controller — confirmPayment only redirects the parent.
export default class extends Controller {
  static values = { intentUrl: String, publishableKey: String, returnUrl: String }
  static targets = ["paymentElement", "submit", "error"]

  connect() {
    this.stripe = Stripe(this.publishableKeyValue)
    this.startCheckout()
  }

  async startCheckout() {
    try {
      const response = await fetch(this.intentUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken()
        }
      })
      const data = await response.json()
      if (!response.ok) {
        this.showError(data.error)
        return
      }
      this.elements = this.stripe.elements({ clientSecret: data.client_secret })
      this.elements.create("payment").mount(this.paymentElementTarget)
      this.submitTarget.disabled = false
    } catch (_error) {
      this.showError("We couldn't start the payment. Please refresh and try again.")
    }
  }

  async submit(event) {
    event.preventDefault()
    if (!this.elements) return

    this.submitTarget.disabled = true
    const { error } = await this.stripe.confirmPayment({
      elements: this.elements,
      confirmParams: { return_url: this.returnUrlValue }
    })
    if (error) {
      this.showError(error.message)
      this.submitTarget.disabled = false
    }
  }

  showError(message) {
    this.errorTarget.textContent = message || "Something went wrong."
    this.errorTarget.classList.remove("hidden")
  }

  csrfToken() {
    return document.querySelector("meta[name='csrf-token']")?.content
  }
}
